import { Form } from './Form';

// TODO: in v9, move styled() from Form.jsx to here
export var StyledForm = Form;